import { render, staticRenderFns } from "./DeudaPorCliente.vue?vue&type=template&id=6b378718&scoped=true&"
import script from "./DeudaPorCliente.vue?vue&type=script&lang=js&"
export * from "./DeudaPorCliente.vue?vue&type=script&lang=js&"
import style0 from "./DeudaPorCliente.vue?vue&type=style&index=0&id=6b378718&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b378718",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDataTable,VIcon,VSpacer,VSubheader,VTextField})
